export default __webpack_public_path__ + "static/media/take-me-away.db5118dc.svg";